import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Header from "./Header";

const SHOP_BY_OCCASION_NAMES = ["shop by occasions", "shop by occasion"];

const MultipleBanner = () => {
    const [banners, setBanners] = useState([]);
    const [occasionSubcategories, setOccasionSubcategories] = useState([]);
    const [subId, setSubId] = useState("");
    const [images, setImages] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);
    const [addingProgress, setAddingProgress] = useState("");
    const [deletingId, setDeletingId] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);

    const fetchBanners = async () => {
        try {
            const res = await fetch('https://projects.sninfoserv.com/welb-api/home/banners/');
            const data = await res.json();
            if (data.status === "success") setBanners(data.data);
            else throw new Error("Failed to fetch banners");
        } catch (err) {
            setError(err.message);
        }
    };

    const fetchOccasionSubcategories = async () => {
        try {
            const [categoriesRes, subcategoriesRes] = await Promise.all([
                axios.get('https://projects.sninfoserv.com/welb-api/admin/categories/categories/'),
                axios.get('https://projects.sninfoserv.com/welb-api/admin/categories/subcategories/'),
            ]);

            if (categoriesRes.data.status !== "success" || subcategoriesRes.data.status !== "success") {
                throw new Error("Failed to fetch categories");
            }

            const occasionCategory = (categoriesRes.data.data || []).find((cat) =>
                SHOP_BY_OCCASION_NAMES.includes((cat.cate || "").trim().toLowerCase())
            );

            if (!occasionCategory) {
                setOccasionSubcategories([]);
                return;
            }

            const filtered = (subcategoriesRes.data.data || []).filter(
                (sub) => String(sub.cat_id) === String(occasionCategory.cat_id)
            );
            setOccasionSubcategories(filtered);
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await Promise.all([fetchBanners(), fetchOccasionSubcategories()]);
            setLoading(false);
        };
        fetchData();
    }, []);

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        setImages(files);
        const newPreviews = files.map((file) => ({
            file,
            url: URL.createObjectURL(file),
            name: file.name,
        }));
        setPreviews(newPreviews);
    };

    const handleRemovePreview = (index) => {
        const updatedPreviews = previews.filter((_, i) => i !== index);
        const updatedImages = images.filter((_, i) => i !== index);
        setPreviews(updatedPreviews);
        setImages(updatedImages);
        if (updatedImages.length === 0 && fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage("");

        if (!subId) { setError("Please select a sub category"); return; }
        if (images.length === 0) { setError("Please select at least one image"); return; }

        setAdding(true);
        let successCount = 0;
        let failCount = 0;

        for (let i = 0; i < images.length; i++) {
            setAddingProgress(`Uploading ${i + 1} of ${images.length}…`);
            try {
                const formData = new FormData();
                formData.append("image", images[i]);
                formData.append("sub_id", subId);

                const response = await fetch('https://projects.sninfoserv.com/welb-api/admin/home/addbanner/', {
                    method: "POST",
                    body: formData,
                });

                const data = await response.json();
                if (data.status === "success") {
                    successCount++;
                } else {
                    failCount++;
                }
            } catch (err) {
                failCount++;
            }
        }

        await fetchBanners();
        setAdding(false);
        setAddingProgress("");

        if (successCount > 0) {
            setSuccessMessage(`${successCount} banner${successCount > 1 ? "s" : ""} added successfully!${failCount > 0 ? ` (${failCount} failed)` : ""}`);
        } else {
            setError("All uploads failed. Please try again.");
        }

        setImages([]);
        setPreviews([]);
        setSubId("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleDelete = async (id) => {
        setDeletingId(id);
        setError(null);
        setSuccessMessage("");
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/delete-sectionbanner/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            });
            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage("Banner removed successfully!");
                setBanners((prev) => prev.filter((b) => b.id !== id));
            } else {
                throw new Error(data.message || "Failed to delete banner");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">

                                {/* Alerts */}
                                {successMessage && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {successMessage}
                                        <button type="button" className="btn-close" onClick={() => setSuccessMessage("")}></button>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {error}
                                        <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Add Banners
                                    </h5>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row align-items-end">


                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label>Sub Category (Shop By Occasions)</label>
                                                    <select
                                                        className="form-control"
                                                        name="sub_category"
                                                        value={subId}
                                                        onChange={(e) => setSubId(e.target.value)}
                                                    >
                                                        <option value="">-- Select Sub Category --</option>
                                                        {occasionSubcategories.map((sub) => (
                                                            <option key={sub.sub_id} value={sub.sub_id}>
                                                                {sub.sub_cate}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label>
                                                        Banner Images
                                                        <span className="text-muted ms-1" style={{ fontSize: "0.78rem" }}>
                                                            (select multiple)
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="image/*"
                                                        multiple
                                                        ref={fileInputRef}
                                                        onChange={handleImageChange}
                                                    />
                                                    {images.length > 0 && (
                                                        <span className="badge bg-primary mt-1">
                                                            {images.length} image{images.length > 1 ? "s" : ""} selected
                                                        </span>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="col-md-2">
                                                <div className="mb-3">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-light-primary text-primary font-medium w-100"
                                                        disabled={adding}
                                                    >
                                                        {adding ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                {addingProgress || "Adding…"}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti ti-plus me-1"></i> Add
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                        {previews.length > 0 && (
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <label className="mb-2 fw-semibold" style={{ fontSize: "0.85rem" }}>
                                                        Preview ({previews.length} image{previews.length > 1 ? "s" : ""})
                                                    </label>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {previews.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className="position-relative"
                                                                style={{ display: "inline-block" }}
                                                            >
                                                                <img
                                                                    src={item.url}
                                                                    alt={`preview-${index}`}
                                                                    style={{
                                                                        width: "120px",
                                                                        height: "75px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                        border: "1px solid #dee2e6",
                                                                        display: "block"
                                                                    }}
                                                                />
                                                                <span
                                                                    className="badge bg-dark"
                                                                    style={{
                                                                        position: "absolute",
                                                                        bottom: "4px",
                                                                        left: "4px",
                                                                        fontSize: "0.65rem"
                                                                    }}
                                                                >
                                                                    {index + 1}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-8px",
                                                                        right: "-8px",
                                                                        borderRadius: "50%",
                                                                        width: "22px",
                                                                        height: "22px",
                                                                        padding: "0",
                                                                        fontSize: "12px",
                                                                        lineHeight: "1"
                                                                    }}
                                                                    onClick={() => handleRemovePreview(index)}
                                                                >
                                                                    <i className="ti ti-x"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </form>

                                <hr />

                                {/* ── TABLE SECTION ── */}
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Section Banners List</h5>
                                    <span className="badge bg-dark fs-6">
                                        {banners.length} {banners.length === 1 ? "Banner" : "Banners"}
                                    </span>
                                </div>

                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Banner Image</th>
                                                <th>Sub Category</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Loading banners…
                                                    </td>
                                                </tr>
                                            ) : banners.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center fw-bold">
                                                        No banners added yet.
                                                    </td>
                                                </tr>
                                            ) : (
                                                banners.map((banner, index) => (
                                                    <tr key={banner.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <img
                                                                src={`https://projects.sninfoserv.com/welb-api/uploads/section-banners/${banner.image}`}
                                                                alt={`banner-${index + 1}`}
                                                                style={{
                                                                    width: "100px",
                                                                    height: "60px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #dee2e6"
                                                                }}
                                                                onError={(e) => e.target.src = "customer_data/no_image.webp"}
                                                            />
                                                        </td>
                                                        <td>
                                                            <span className="badge bg-light-primary text-primary">
                                                                {occasionSubcategories.find((sub) => String(sub.sub_id) === String(banner.sub_id))?.sub_cate || "N/A"}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="btn-group">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(banner.id)}
                                                                    disabled={deletingId === banner.id}
                                                                >
                                                                    {deletingId === banner.id ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                                            Removing…
                                                                        </>
                                                                    ) : (
                                                                        <i className="ti ti-trash"></i>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
};

export default MultipleBanner;